import { AxiosError } from "axios";
import { RowKey } from "src/requests/table/types";
import { TemplateId } from "../../../globalTypes";
import * as requests from "../../../requests/templates/requestCreators";
import { EwaThunk } from "../../types";
import * as actions from "../actions";
import * as selectors from "../selectors";
import { mapApiToDispatch } from "./utils";

const fetchTemplateMetadataForTemplateId =
  (templateId: TemplateId, rowKey?: RowKey): EwaThunk =>
  async (dispatch, getState) => {
    const state = getState();

    const isFetching = selectors.getIsMetadataFetchingForTemplateId(
      state,
      templateId
    );
    if (isFetching) return;

    dispatch(actions.requestFetchTemplateMetadata(templateId));

    try {
      const response = await requests.fetchTemplateMetadata(templateId, rowKey);
      const templateMetadata = response.data;

      dispatch(
        actions.successFetchTemplateMetadata(mapApiToDispatch(templateMetadata))
      );
    } catch (e) {
      // error handling
      if (!(e as AxiosError).response) throw e;
      dispatch(
        actions.errorFetchTemplateMetadata(
          templateId,
          (e as AxiosError).response
        )
      ); // TODO: nějak to rozparsovat
    }
  };

export default fetchTemplateMetadataForTemplateId;
